import React, { useState } from 'react';
import { useStyles } from './OnboardingFlow.styles';
import { TermsAndConditions } from '../../components/Onboarding/TermsAndConditions';
import { ConnectDataProvider } from '../../components/Onboarding/ConnectDataProvider';
import { FinalOnboardingStep } from '../../components/Onboarding/FinalOnboardingStep';
import { useNavigate } from 'react-router-dom';

export type OnboardingData = {
  connectDataProvider?: {
    providerKey: string;
  };
  termsAndConditions?: {
    accepted: boolean;
  };
};

const ONBOARDING_STEPS = [
{ key: 'terms', title: 'Terms and Conditions' },
{ key: 'connect', title: 'Connect to a data provider' },
{ key: 'setup', title: 'Setting things up' }] as
const;

const TOTAL_STEPS = ONBOARDING_STEPS.length;

export const OnboardingFlow: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [onboardingData, setOnboardingData] = useState<OnboardingData>({});

  const handleStepNext = async (stepData: OnboardingData) => {

    setOnboardingData((prevData) => ({ ...prevData, ...stepData }));

    setCurrentStep((prevStep) => prevStep + 1);
  };

  const handleStepBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    } else {
      navigate('/');
    }
  };

  const renderStepContent = () => {

    switch (currentStep) {
      case 0:
        return (
          <TermsAndConditions
            onNext={handleStepNext}
            onBack={handleStepBack}
            currentStep={currentStep}
            totalSteps={TOTAL_STEPS} data-testid="onboarding-flow-onboarding-flow-terms-and-conditions" />);


      case 1:
        return (
          <ConnectDataProvider
            onNext={handleStepNext}
            onBack={handleStepBack}
            currentStep={currentStep}
            totalSteps={TOTAL_STEPS} data-testid="onboarding-flow-onboarding-flow-connect-data-provider" />);


      case 2:
        return (
          <FinalOnboardingStep
            onboardingData={onboardingData}
            onNext={() => navigate('/')}
            onBack={handleStepBack}
            currentStep={currentStep}
            totalSteps={TOTAL_STEPS} data-testid="onboarding-flow-onboarding-flow-final-onboarding-step" />);


      default:
        return null;
    }
  };

  return (
    <div className={styles.wizard} data-testid="onboarding-flow-onboarding-flow-wizard-div">
      <div className={styles.content} data-testid="onboarding-flow-onboarding-flow-content-div">
        {renderStepContent()}
      </div>
    </div>);

};